
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/enquiryList.css";

// DEVELOPMENT MOCK DATA ONLY. Replace after API contracts and visual approval.
const SAMPLE = [
  {id:"ENQ-2026-10-000241",company:"ABC Manufacturing Ltd.",contact:"Rahul Sharma",source:"Website",owner:"Ankit Mehra",score:82,status:"Qualified",priority:"High",activity:"Today, 10:42 AM",date:"2026-10-19",industry:"Manufacturing"},
  {id:"ENQ-2026-10-000240",company:"XYZ Technologies",contact:"Priya Nair",source:"Referral",owner:"Neha Kapoor",score:64,status:"In Progress",priority:"Medium",activity:"Today, 09:18 AM",date:"2026-10-19",industry:"Technology"},
  {id:"ENQ-2026-10-000239",company:"LKM Automotive",contact:"Vikram Singh",source:"Trade Show",owner:"Amit Verma",score:47,status:"New",priority:"High",activity:"Yesterday",date:"2026-10-18",industry:"Automotive"},
  {id:"ENQ-2026-10-000238",company:"PQR Retail Group",contact:"Sneha Iyer",source:"Campaign",owner:"Rohit Das",score:76,status:"Assigned",priority:"Low",activity:"17 Oct, 03:12 PM",date:"2026-10-17",industry:"Retail"},
  {id:"ENQ-2026-10-000237",company:"Global Packaging Co.",contact:"Mohit Gupta",source:"Email",owner:"Ankit Mehra",score:91,status:"Converted",priority:"Critical",activity:"16 Oct, 11:30 AM",date:"2026-10-16",industry:"Manufacturing"},
  {id:"ENQ-2026-10-000236",company:"Sunrise Components",contact:"Kavita Rao",source:"Website",owner:"Unassigned",score:31,status:"Lost",priority:"Medium",activity:"15 Oct, 04:20 PM",date:"2026-10-15",industry:"Manufacturing"},
  {id:"ENQ-2026-10-000235",company:"Northstar Logistics",contact:"Arjun Patel",source:"Partner",owner:"Neha Kapoor",score:58,status:"In Progress",priority:"Low",activity:"14 Oct, 02:05 PM",date:"2026-10-14",industry:"Logistics"}
];

const STATUSES = ["New","Assigned","In Progress","Qualified","Converted","Lost","Closed","Cancelled"];
const SOURCES = ["Website","Referral","Trade Show","Campaign","Email","Partner"];
const PRIORITIES = ["Low","Medium","High","Critical"];
const key = s => s.toLowerCase().replace(/\s+/g,"-");

export default function EnquiryList() {
  const navigate = useNavigate();

  const [query,setQuery] = useState("");
  const [status,setStatus] = useState("");
  const [source,setSource] = useState("");
  const [priority,setPriority] = useState("");
  const [owner,setOwner] = useState("");
  const [from,setFrom] = useState("");
  const [to,setTo] = useState("");
  const [preset,setPreset] = useState("All Enquiries");
  const [selected,setSelected] = useState([]);
  const [notice,setNotice] = useState("");

  const rows = useMemo(() => SAMPLE.filter(r => {
    const q = query.trim().toLowerCase();
    const matchSearch = !q || [r.id,r.company,r.contact,r.source,r.owner]
      .some(v => v.toLowerCase().includes(q));

    const matchPreset =
      preset === "All Enquiries" ||
      (preset === "My Enquiries" && r.owner === "Ankit Mehra") ||
      (preset === "Open" && !["Converted","Lost","Closed","Cancelled"].includes(r.status)) ||
      (preset === "Assigned" && r.owner !== "Unassigned") ||
      (preset === "Qualified" && r.status === "Qualified") ||
      (preset === "Lost" && r.status === "Lost") ||
      (preset === "Converted" && r.status === "Converted");

    return matchSearch && matchPreset &&
      (!status || r.status === status) &&
      (!source || r.source === source) &&
      (!priority || r.priority === priority) &&
      (!owner || r.owner === owner) &&
      (!from || r.date >= from) &&
      (!to || r.date <= to);
  }), [query,status,source,priority,owner,from,to,preset]);

  const reset = () => {
    setQuery("");
    setStatus("");
    setSource("");
    setPriority("");
    setOwner("");
    setFrom("");
    setTo("");
    setPreset("All Enquiries");
    setSelected([]);
  };

  const allSelected = rows.length > 0 && rows.every(r => selected.includes(r.id));
  const say = m => setNotice(m);

  const selectAll = () => setSelected(old =>
    allSelected
      ? old.filter(id => !rows.some(r => r.id === id))
      : [...new Set([...old,...rows.map(r => r.id)])]
  );

  return (
    <div className="elosca-enquiry-list">
      <div className="elosca-breadcrumb">
        Home <b>›</b> Sales <b>›</b> <strong>Enquiry Management</strong>
      </div>

      <div className="elosca-page-heading">
        <div>
          <h1>Enquiries</h1>
          <p>Manage, track, and qualify your sales enquiries.</p>
        </div>
        <span className="elosca-sample-tag"><i /> Sample data preview</span>
      </div>

      <section className="elosca-kpis">
        <Kpi label="Total Enquiries" value="2,845" tone="blue" icon="▦" />
        <Kpi label="New" value="325" tone="purple" icon="✦" />
        <Kpi label="Qualified" value="876" tone="green" icon="◎" />
        <Kpi label="Converted" value="1,204" tone="teal" icon="↗" />
        <Kpi label="Lost" value="440" tone="red" icon="⊘" />
        <Kpi label="Conversion Rate" value="42.30%" tone="amber" icon="◷" />
      </section>

      <section className="elosca-toolbar">
        <div className="elosca-toolbar-left">
          <button
            className="elosca-btn primary"
            onClick={() => navigate("/elosca-crm/enquiry/create")}
          >
            ＋ Create Enquiry
          </button>

          <button className="elosca-btn" onClick={() => say("Import Enquiries is Screen 9; this is a mock action.")}>
            ⇧ Import
          </button>

          <button className="elosca-btn" onClick={() => say("Mock preview only: no export file was generated.")}>
            ⇩ Export
          </button>

          <button
            className="elosca-btn"
            disabled={!selected.length}
            onClick={() => say(`Mock action: ${selected.length} selected record(s) ready for assignment.`)}
          >
            Assign{selected.length ? ` (${selected.length})` : ""}
          </button>

          <button
            className="elosca-btn"
            disabled={!selected.length}
            onClick={() => say(
              rows.some(r => selected.includes(r.id) && r.status === "Qualified")
                ? "Qualified records can proceed after duplicate and permission checks."
                : "Only Qualified enquiries can proceed to conversion."
            )}
          >
            Convert
          </button>
        </div>

        <button className="elosca-btn" onClick={() => say("Additional actions will follow approved requirements.")}>
          More⌄
        </button>
      </section>

      {notice && (
        <div className="elosca-notice" role="status">
          <span>{notice}</span>
          <button onClick={() => setNotice("")} aria-label="Dismiss">×</button>
        </div>
      )}

      <section className="elosca-filter-card">
        <div className="elosca-search-row">
          <label className="elosca-searchbox">
            <span>⌕</span>
            <input
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Search enquiry number, company, mobile, email, contact..."
              aria-label="Search enquiries"
            />
          </label>

          <button
            className="elosca-btn"
            onClick={() => document.getElementById("elosca-filters")?.classList.toggle("open")}
          >
            ⚙ Filters
          </button>

          <button className="elosca-btn" onClick={reset}>Reset</button>
        </div>

        <div className="elosca-presets">
          {["All Enquiries","My Enquiries","Open","Assigned","Qualified","Lost","Converted"].map(p => (
            <button
              key={p}
              className={preset === p ? "active" : ""}
              onClick={() => setPreset(p)}
            >
              {p}
            </button>
          ))}
        </div>

        <div className="elosca-advanced-filters" id="elosca-filters">
          <Filter label="Status" value={status} onChange={setStatus} options={STATUSES} />
          <Filter label="Source" value={source} onChange={setSource} options={SOURCES} />
          <Filter label="Priority" value={priority} onChange={setPriority} options={PRIORITIES} />
          <Filter
            label="Owner"
            value={owner}
            onChange={setOwner}
            options={["Ankit Mehra","Neha Kapoor","Amit Verma","Rohit Das","Unassigned"]}
          />
          <label className="elosca-filter-field">
            From date
            <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
          </label>
          <label className="elosca-filter-field">
            To date
            <input type="date" value={to} onChange={e => setTo(e.target.value)} />
          </label>
        </div>
      </section>

      <section className="elosca-table-card">
        <div className="elosca-table-heading">
          <div>
            <h2>Enquiry Register</h2>
            <p>{rows.length} sample record{rows.length === 1 ? "" : "s"} shown</p>
          </div>
          <span>
            Mock data only
            <button
              className="elosca-icon-btn"
              onClick={() => say("Refresh will connect to the backend later.")}
              aria-label="Refresh"
            >
              ↻
            </button>
          </span>
        </div>

        <div className="elosca-table-wrap">
          <table className="elosca-table">
            <thead>
              <tr>
                <th><input type="checkbox" checked={allSelected} onChange={selectAll} aria-label="Select visible records" /></th>
                <th>Enquiry No.</th>
                <th>Company</th>
                <th>Contact</th>
                <th>Source</th>
                <th>Owner</th>
                <th>Score</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Last Activity</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {rows.map(r => (
                <tr
                  key={r.id}
                  onClick={() => navigate(`/elosca-crm/enquiry/${encodeURIComponent(r.id)}`)}
                  style={{ cursor: "pointer" }}
                >
                  <td onClick={e => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={selected.includes(r.id)}
                      onChange={() => setSelected(old =>
                        old.includes(r.id)
                          ? old.filter(id => id !== r.id)
                          : [...old,r.id]
                      )}
                      aria-label={`Select ${r.id}`}
                    />
                  </td>

                  <td>
                    <button
                      className="elosca-link"
                      onClick={e => {
                        e.stopPropagation();
                        navigate(`/elosca-crm/enquiry/${encodeURIComponent(r.id)}`);
                      }}
                    >
                      {r.id}
                    </button>
                  </td>

                  <td><b>{r.company}</b><small>{r.industry}</small></td>
                  <td>{r.contact}<small>Contact details in record</small></td>
                  <td><span className="elosca-source"><i />{r.source}</span></td>
                  <td>
                    <span className="elosca-owner-avatar">
                      {r.owner === "Unassigned" ? "—" : r.owner.split(" ").map(x => x[0]).join("")}
                    </span>{" "}
                    {r.owner}
                  </td>
                  <td>
                    <span className="elosca-score">
                      {r.score}
                      <i><b style={{ width: `${r.score}%` }} /></i>
                    </span>
                  </td>
                  <td><span className={`elosca-status s-${key(r.status)}`}>{r.status}</span></td>
                  <td><span className={`elosca-priority p-${r.priority.toLowerCase()}`}>● {r.priority}</span></td>
                  <td>{r.activity}</td>
                  <td>
                    <button
                      className="elosca-icon-btn"
                      onClick={e => {
                        e.stopPropagation();
                        say(`Actions for ${r.id} are mock-only.`);
                      }}
                      aria-label={`Actions ${r.id}`}
                    >
                      ⋮
                    </button>
                  </td>
                </tr>
              ))}

              {!rows.length && (
                <tr>
                  <td colSpan="11" className="elosca-empty">
                    <b>No enquiries match these filters</b>
                    <p>Try changing your search or resetting the filters.</p>
                    <button className="elosca-btn" onClick={reset}>Clear filters</button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="elosca-pagination">
          <span>Showing {rows.length ? 1 : 0}–{rows.length} of {rows.length} sample records</span>
          <div>
            <button disabled>‹ Prev</button>
            <button className="current">1</button>
            <button disabled>Next ›</button>
            <select aria-label="Rows per page" defaultValue="10">
              <option value="10">10 / page</option>
              <option value="25">25 / page</option>
              <option value="50">50 / page</option>
            </select>
          </div>
        </div>
      </section>

      <p className="elosca-footnote">
        Development preview · Sample data only · No records saved or changed.
      </p>
    </div>
  );
}

function Kpi({ label, value, tone, icon }) {
  return (
    <article className={`elosca-kpi k-${tone}`}>
      <div>{label}<span>{icon}</span></div>
      <strong>{value}</strong>
      <small>Reference values from design mockup</small>
    </article>
  );
}

function Filter({ label, value, onChange, options }) {
  return (
    <label className="elosca-filter-field">
      {label}
      <select value={value} onChange={e => onChange(e.target.value)}>
        <option value="">All {label.toLowerCase()}s</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}
